import {useContext} from "react"
import { CreateClientContext } from "./context"

export function useCreatClientHook() {
    return useContext(CreateClientContext);
}